<template>
  <QPage class="column q-pa-lg">
    <h6
      :class="{
        'q-ma-none text-weight-bold text-grey-9': true,
        'q-mb-md': !$store.getters['quote/canCreate']
      }"
    >
      {{ this.title }}
    </h6>

    <QuoteTabs
      :disabled="$apollo.queries.getQuoteDetail.loading"
      v-if="$store.getters['quote/canCreate']"
    />

    <QCard
      class="row justify-center items-center q-py-xl"
      v-if="$apollo.queries.getQuoteDetail.loading"
    >
      <LoadingVehicle />
    </QCard>

    <div class="row q-gutter-md" v-else>
      <QCard class="col q-pa-lg self-start" bordered :key="dbquoteId">
        <div v-if="error" class="text-body3 text-grey-9">{{ error }}</div>
        <router-view v-else />
      </QCard>

      <div class="col-xs-4 col-sm-5 col-md-4 col-lg-3">
        <QuoteSummaryCard
          :vehicle-loading="$apollo.queries.getQuoteDetail.loading"
          :finance-loading="$apollo.queries.getQuoteDetail.loading"
          class="q-mb-md"
        />

        <QuoteReviewActions v-if="$route.name === 'quoteReview' && dbquoteId" />
      </div>
    </div>
  </QPage>
</template>

<script>
import { QPage, QCard } from 'eclipx.ui';
import { mapState, mapMutations } from 'vuex';
import { NewQuoteRouteParam } from '../../router/Routes';
import QuoteTabs from './QuoteTabs';
import QuoteSummaryCard from '../../components/QuoteSummaryCard/QuoteSummaryCard';
import QueryQuote from '../../graphql/queries/QueryQuote';
import QuoteReviewActions from '../../components/QuoteReviewActions/QuoteReviewActions';
import { initialQuote } from '../../store/modules/quotes/quoteStore';
import { GLOBAL_ERROR } from '../../components/GlobalError/GlobalError';
import LoadingVehicle from '../../components/LoadingVehicle/LoadingVehicle';

export default {
  name: 'Quote',
  data() {
    return {
      error: null
    };
  },
  computed: {
    ...mapState({
      quote: (state) => state.quote.quote,
      dbquoteId: (state) => state.quote.quote.dbquote.id,
      erpQuoteRef: (state) => state.quote.quote.erpquote.erpQuoteRef
    }),
    title() {
      if (this.$apollo.queries.getQuoteDetail.loading) {
        return '⠀';
      }

      return this.dbquoteId ? `Quote: ${this.erpQuoteRef}` : 'New Quote';
    },
    routeId() {
      return this.$route.params.quoteId;
    }
  },
  apollo: {
    getQuoteDetail: {
      query: QueryQuote,
      fetchPolicy: 'network-only',
      variables() {
        return {
          dbQuoteId: this.routeId
        };
      },
      skip() {
        return this.routeId === NewQuoteRouteParam || this.error;
      },
      update(data) {
        let quote = data.getQuoteDetail || initialQuote;
        this.setQuote(quote);
        return quote;
      },
      error(error) {
        if (error) {
          let gqlError = error.graphQLErrors[0];
          this.error = gqlError ? gqlError.message : 'Error';
          this.$euiNotifications.emit({
            notification: GLOBAL_ERROR,
            action: () => {
              return this.$apollo.queries.getQuoteDetail.refresh();
            }
          });
        }
      }
    }
  },
  created() {
    // Reset the stored quote if saved and going to a new quote route
    if (this.routeId === NewQuoteRouteParam && this.dbquoteId) {
      this.createNewQuote();
    }
  },
  methods: {
    ...mapMutations({
      createNewQuote: 'quote/createNewQuote',
      setQuote: 'quote/setQuote'
    })
  },
  components: {
    LoadingVehicle,
    QPage,
    QuoteTabs,
    QuoteSummaryCard,
    QCard,
    QuoteReviewActions
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped></style>
